import Axios from "axios";

const getSiteVisitReport = async (id, token) =>
  await Axios.get(`${window.API}/site-visit/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export { getSiteVisitReport };
